import {
  flatMap, concat, filter, get, isEmpty,
} from 'lodash';
import ShippingLabel from './ShippingLabel';
import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();

export default {
  async update(card) {
    try {
      await checkLicenseExpiry();
      const params = {
        inLineEdit: true,
        projectId: card.project._id,
        recipient: card.delivery.recipient._id,
        owner: card.delivery.owner._id,
        trackingId: card.delivery.trackingId,
        externalEmails: card.delivery.externalEmails,
        shippingLabelId: card._id,
        transitId: card.delivery._id,
        name: card.name,
        files: card.files.length ? card.files : [],
        notify: flatMap(card.delivery.notify, '_id'),
        notes: card.delivery.notes,
        deliveryStart: card.delivery.deliveryStart,
        deliverBy: card.delivery.deliverBy,
        currentLocation: card.delivery.currentLocation._id,
        deliveryLocation: card.delivery.deliveryLocation._id,
      };
      if (!isEmpty(card.minShipDate)) {
        params.deliveryStart = card.minShipDate;
      }
      if (!isEmpty(card.maxdeliverDate)) {
        params.deliverBy = card.maxdeliverDate;
      }
      const { data: shipping } = await req.post('shipping/transit/update', params);
      return new ShippingLabel(shipping);
    } catch (e) {
      // TODO: Add an alert here?
      console.log(e);
      return {};
    }
  },
  async get(params = {}) {
    params = {
      limit: 25,
      page: 1,
      status: ['not-started', 'in-transit', 'in-storage', 'fulfilled'],
      ...params,
    };
    try {
      await checkLicenseExpiry();
      const { data: shipping } = await req.get('shipping/get', { params });
      shipping.data = shipping.data.map((s) => {
        s.files = s.files.filter(f => !f.archived.value);
        return new ShippingLabel(s);
      });
      return shipping;
    } catch (e) {
      console.log(e);
      throw e;
      // TODO: Throw an error dialog box?
    }
  },
  async getItemView(params) {
    try {
      await checkLicenseExpiry();
      const { data: shipping } = await req.get('shipping/getItemView', { params });
      shipping.data = shipping.data.map(s => new ShippingLabel(s));
      return shipping;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async createDeliveries(params) {
    const { data } = await req.post('shipping/partial/createDeliveries', params);
    return data;
  },
  async addTransit(params = {}) {
    try {
      await checkLicenseExpiry();
      params.files = filter(params.files, f => !f.master);
      const { data: shipping } = await req.post('shipping/transit/add', params);
      return new ShippingLabel(shipping);
    } catch (e) {
      console.log(e);
      throw e;
      // TODO: Throw an error dialog box?
    }
  },
  async updateTransit(params = {}) {
    try {
      await checkLicenseExpiry();
      const { data: shipping } = await req.post('shipping/transit/update', params);
      return new ShippingLabel(shipping);
    } catch (e) {
      console.log(e);
      throw e;
      // TODO: Throw an error dialog box?
    }
  },
  async addFromPO(params = {}) {
    try {
      await checkLicenseExpiry();
      const { data: shipping } = await req.post('/shipping/add/fromPOs', params);
      return new ShippingLabel(shipping);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async receiveAll(params = {}) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/receive/all', params);
      return new ShippingLabel(data);
    } catch (e) {
      console.log(e);
      throw e;
      // TODO: Throw an error dialog box?
    }
  },
  async create(ship) {
    try {
      await checkLicenseExpiry();
      const { data: shipment } = await req.post('/shipping/new', ship);
      return new ShippingLabel(shipment);
    } catch (e) {
      console.log(e);
      throw (e);
    }
  },
  async split(params = {}) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/split', params);
      return new ShippingLabel(data);
    } catch (e) {
      console.log(e);
      throw e;
      // TODO: Throw an error dialog box?
    }
  },
  async createPurchaseReceipts(params) {
    try {
      await checkLicenseExpiry();
      const { data: shipments } = await req.post('/shipping/purchaseReceipts', params);
      shipments.purchaseLabel = shipments.purchaseLabel.map(s => new ShippingLabel(s));
      return shipments;
    } catch (e) {
      console.log(e);
      throw (e);
    }
  },
  async getPurchaseShippingOrders(params) {
    try {
      await checkLicenseExpiry();
      const { data: shipping } = await req.get('/shipping/getPurchaseShippingOrders', { params });
      shipping.data = shipping.data.map((s) => {
        s.files = s.files.filter(f => !f.archived.value);
        return new ShippingLabel(s);
      });
      return shipping;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getCompletedItems(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.get(
        `/materials/getCompletedItems/${params._id}`,
        { params: { projectId: params.project._id || '' } },
      );
      return data;
    } catch (e) {
      console.log(e);
      throw e;
      // TODO: Throw an error dialog box?
    }
  },
  // async markFulfilled(params) {
  //   A shipment can now be marked fulfilled using the 'receiveAll' call itself by
  //   setting 'isFinal' param to true
  // },
  async markConsumed(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/markConsumed', params);
      return new ShippingLabel(data);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async splitFromLabels(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/add/fromOtherLabels', params);
      return new ShippingLabel(data);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async removeItems(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/remove/items', params);
      return data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async updateShippingDetails(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/update/shippingDetails/', params);
      return new ShippingLabel(data);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async cancelShipping(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/transit/cancel', params);
      return new ShippingLabel(data);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getDetailedLabel(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.get(`/shipping/details/${params.shippingId}`, { params });
      return new ShippingLabel(data);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async unreserveItems(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/unreserve', params);
      if (data.labels) {
        Object.assign(data, {
          labels: data.labels.map(label => new ShippingLabel(label)),
        });
      }
      return data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async releaseToInventory(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/release', params);
      return new ShippingLabel(data);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getShippingLabel(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.get(`/qr/shippinglabel/${params.shippingId}`, { params });
      return data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async breakShipmentIntoPartials(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/partial/save', params);
      const newShipment = new ShippingLabel(data.mLabel);
      Object.assign(newShipment, {
        partialShipments: data.partials.map((p) => {
          p.itemSources = newShipment.itemSources;
          p.files = concat(data.mLabel.files, p.files);
          return new ShippingLabel(p);
        }),
        summary: newShipment.summary,
      });
      return newShipment;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async relaunch(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/revive', params);
      return new ShippingLabel(data);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getPartialShipments(params) {
    try {
      await checkLicenseExpiry();
      if (params.shippingLabelId === 'undefined' || isEmpty(params.shippingLabelId)) {
        return {};
      }
      const { data } = await req.get('/shipping/partial/get', { params });
      if (data.partials.length === 0
        && data.mLabel
        && data.mLabel.shipType === 's-m') {
        data.partials.push(data.mLabel);
      }
      data.mLabel.files = data.mLabel.files.map((f) => {
        f.master = true;
        return f;
      });
      const newShipment = new ShippingLabel(data.mLabel);
      Object.assign(newShipment, {
        partialShipments: data.partials.map((p) => {
          p.items = filter(p.items, item => item.quantity);
          // p.files = data.mLabel.files;
          p.itemSources = newShipment.itemSources;
          return new ShippingLabel(p);
        }),
      });

      const itemMap = {};
      for (const pl of newShipment.partialShipments) {
        for (const item of pl.items) {
          const key = item.catId !== '' ? 'catId' : '_id';
          if (item.underDeliver) {
            const itemKey = item[key];
            if (itemMap[itemKey]) {
              const sameItem = itemMap[itemKey];
              // sameItem.underDeliver += item.underDeliver;
              if (sameItem.issueNote === '' && item.sameItem !== '') {
                sameItem.issueNote = item.issueNote;
              } else if (sameItem.issueNote !== '' && sameItem.sameItem !== item.issueNote) {
                sameItem.issueNote = 'Mixed';
              }
            } else {
              itemMap[itemKey] = item;
            }
          }
        }
      }

      for(const item of newShipment.items) {
        const itemKey = item.id;
        if(itemMap[itemKey]) {
          item.underDeliver = itemMap[itemKey].underDeliver;
          item.issueNote = itemMap[itemKey].issueNote;
        } else {
          item.underDeliver = 0;
          item.issueNote = '';
        }
      }



      return newShipment;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async removeItemsFromPartial(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/partial/removeItems', params);
      return data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async generatePdf(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('reportings/addPdfToQueue', { params });
      return data;
    } catch (e) {
      throw e;
    }
  },
  async archive(id) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('shipping/archiveLabel', { id });
      return data;
    } catch (e) {
      throw e;
    }
  },
  async consumeAndUnreserve(params) {
    try {
      await checkLicenseExpiry();
      const orderId = get(params, 'order._id', '');
      const { data } = await req.post(`shipping/consumeAndUnreserve/${orderId}`);
      return data;
    } catch (e) {
      throw e;
    }
  },
  async reserveCatalog(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post(`shipping/reserveMaterials/${params.cardId}`);
      return data;
    } catch (e) {
      throw e;
    }
  },
  async getLinkedShippingOrders(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.get(`shipping/linkedShippingOrders/${params.cardId}`);
      return data;
    } catch (e) {
      throw e;
    }
  },
  async createEmptyLabel(params) {
    try {
      await checkLicenseExpiry();
      const {data} = await req.post(`shipping/createEmptyLabel`, params);
      return data.data;
    } catch (e) {
      throw e;
    }
  },
  // This API takes the following parameters:
  // {
  //   projectId,
  //   locationId
  // }
  async getCompletedPOItems(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.get(`/shipping/getPOCompletedItems/${params.projectId}&${params.locationId}`, {params});
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /* This API takes the following parameters:
  {
    fromParentSLId,
    toChildSLId,
    items: {
      <----- Need the item fields and the following extra fields ----->
      moveQuantity,
      availableQty,
      cardId,
      runId
    }
    projectId,
    locationId
  }
  */
  async moveCompletedPOItems(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/moveCompletedPOItems', params);
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /*
    This API endpoint takes the following parameters:
    {
      name, // Name of the empty delivery.
      parentShipmentId,
      deliveryStart: {
        val,
        kind
      },
      deliverBy: {
        val,
        kind
      }
    }
  */
  async addEmptyDelivery(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/addEmptyDelivery', params);
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async generateShippingPdf(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('reportings/generateShippingListPdf', params);
      return data;
    } catch (e) {
      throw e;
    }
  },
  /*
    This API endpoint expects the following parameters:
    {
      name, // Name of the empty delivery.
      parentShipmentId,
      deliveryStart: {
        val,
        kind
      },
      deliverBy: {
        val,
        kind
      },
      existingSlId, // The id of the existing delivery
      itemId  // The id of the short item
    }
  */
  async pickShortDelivery(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/shortQuantityRedeliver', params);
      return data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  /*
    This API endpoint expects the following parameters:
    {
      parentId, // Master shipping id.
      itemId
    }
  */
  async ignoreShort(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('/shipping/ignoreShort', params);
      return data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  }
};
